import React from "react";
import {Button, Modal} from "react-bootstrap";

/**
 * Hinweis für den Sammelzugang der Probearbeiter (z. B. sales@molotow.com).
 * Über diesen Zugang lassen sich keine Support-Tickets erstellen - ein
 * Ticket bräuchte einen eindeutigen Melder, den es bei einem geteilten
 * Zugang nicht gibt. Wird sowohl beim Klick auf den Support-Einstieg
 * (SupportHeaderControl/SupportSidebarControl, dort statt des
 * Ticket-Formulars) als auch einmalig nach der Anmeldung gezeigt
 * (SharedAccountLoginNotice).
 */
export default function SharedAccountHint({show, onClose}) {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title className="fs-5">Zugang für Probearbeiter</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0">
                    Du bist gerade mit dem Zugang für Probearbeiter angemeldet. Darüber
                    lassen sich keine Support-Tickets erstellen. Bitte melde dich mit
                    deinem persönlichen Zugang an, um ein Ticket zu schreiben.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onClose}>
                    Verstanden
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
